import React, { ComponentType } from "react";
import { useSocket } from "./socket/SocketContext";
import { ISocketMsg } from "./socket/types";

// 定義 socket 相關的 props 介面
export interface WithSocketProps {
  socketMsg?: ISocketMsg;
  setDetailPage?: (data: string) => void;
  setBookPage?: (data: string) => void;
  setCloseBook?: (data: string) => void;
  sessionId?: string;
  memberId?: number;
}

export function withSocket<P extends WithSocketProps>(
  WrappedComponent: ComponentType<P>
) {
  // 返回一個新的函數組件
  const WithSocketComponent = (props: Omit<P, keyof WithSocketProps>) => {
    const socketProps = useSocket();
    
    // 合併 props 和 socket props
    return <WrappedComponent {...(props as P)} {...socketProps} />;
  };

  // 設置顯示名稱，方便調試
  const wrappedComponentName = 
    WrappedComponent.displayName || 
    WrappedComponent.name || 
    'Component';
  WithSocketComponent.displayName = `WithSocket(${wrappedComponentName})`;

  return WithSocketComponent;
}